import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { CopiiService } from '../copii.service';
import { Copil, CopilUpdate } from '../copii.interface';

@Component({
    selector: 'app-edit-copii',
    templateUrl: './edit-copii.component.html',
    styleUrls: ['./edit-copii.component.scss']
})
export class EditCopiiComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        first_name: new FormControl(this.data.first_name, Validators.required),
        last_name: new FormControl(this.data.last_name, Validators.required),
        parintii: new FormControl(this.data.personal_data.parintii, Validators.required),
        birth_date: new FormControl(this.data.birth_date, Validators.required),
        cnp: new FormControl(this.data.cnp, Validators.required),
        locatie: new FormControl(this.data.personal_data.locatie, Validators.required),
        email: new FormControl(this.data.contact_info.email, Validators.required),
        telefon: new FormControl(this.data.contact_info.telefon, Validators.required),
        status: new FormControl(this.data.personal_data.status, Validators.required),
        observatii: new FormControl(this.data.notes),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditCopiiComponent>,
        private copiiService: CopiiService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.copiiService.setToken(token);
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { first_name, last_name, parintii, status, birth_date, cnp, locatie, email, telefon, observatii } = this.form.value as any;

        const updatedCopil: CopilUpdate = {
            first_name,
            last_name,
            parintii,
            status,
            birth_date: birth_date ? this.formatDate(birth_date) : '',
            cnp,
            locatie,
            email,
            telefon,
            observatii,
            id: this.data.id,
        };

        this.copiiService
            .updateCopil(updatedCopil)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
